import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ButtonModule, DialogModule } from 'primeng';

@Component({
  selector: 'combine-grab-disabled-job-dialog',
  standalone: true,
  imports: [CommonModule, DialogModule, ButtonModule],
  templateUrl: './combine-grab-disabled-job-dialog.component.html',
  styleUrls: ['./combine-grab-disabled-job-dialog.component.css'],
})
export class CombineGrabDisabledJobDialogComponent implements OnInit {
  @Input() visible: boolean;
  @Output() visibleChange: EventEmitter<boolean> = new EventEmitter<boolean>();

  @Output() onConfirm: EventEmitter<void> = new EventEmitter<void>();

  protected confirm() {
    this.visibleChange.emit(false);
    this.onConfirm.emit();
  }

  constructor() {}

  ngOnInit(): void {}
}
